import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Card, Error, Spinner } from 'src/components';
import { useGetRentalsFromFirestore, useQueryHelper } from 'src/queries';
import { useLanguageState, useOrganizationState } from 'src/state';
import { RentalFirestoreResponse } from 'src/types';

import { Title } from './Rentals.styled';

export const Rentals: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { organizationData } = useOrganizationState();
  const { language: currentLang } = useLanguageState();
  const rentalsCollections = useGetRentalsFromFirestore(organizationData.hotel);
  const { data: rentals, refetch } = rentalsCollections;
  const { isLoading, isError } = useQueryHelper({ queries: [rentalsCollections] });

  if (isLoading) {
    return (
      <Spinner global />
    );
  }

  if (isError) {
    return <Error info errorTitle="Brak dostępnych rzeczy w wypożyczalni" action={refetch} />;
  }
  return (
    <>
      <Helmet>
        <title>Hotelspot | Wypożyczalnia</title>
        <meta name="description" content="Hotelspot - Wypożyczalnia" />
      </Helmet>
      <div>
        <Title />{t('rent_screen.rent')} <Title />
        <div className="grid sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-4">
          {!!rentals?.length && rentals?.map((rental: RentalFirestoreResponse) => (
            <Card
              priceLabel={rental.price}
              time={`${rental.time_from} - ${rental.time_to}`}
              key={rental.id}
              image={rental?.cover || ''}
              isVertical
              title={rental.title[currentLang]}
              action={() => navigate(`/rental/${rental?.id}`)}
            />
          ))}
        </div>
      </div>
    </>
  );
};
